import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { activityResultTypeToText } from '@dxp/core/helpers';
import {
    ConversationEndedReason,
    DequeuedReason,
    EnqueueAttemptRejectReason,
    WorkItemResult,
} from '@dxp/core/types';

@Component({
    selector: 'telxl-activity-result-tag',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './activity-result-tag.component.html',
    styleUrls: ['./activity-result-tag.component.scss'],
    host: {
        '[class]': 'class || ""',
    },
})
export class TelXLActivityResultTagComponent {
    activityResultTypeToText = activityResultTypeToText;

    @Input({ required: true }) result!:
        | WorkItemResult
        | DequeuedReason
        | EnqueueAttemptRejectReason
        | ConversationEndedReason;
    @Input() outline = false;

    get resultClass(): 'red' | 'green' | 'orange' | 'blue' | 'purple' | 'grey' {
        switch (this.result) {
            case 'Abandoned':
            case 'Cancelled':
            case 'Failed':
            case 'Missed':
            case 'Rejected':
            case 'Discarded':
            case 'AgentJoinFailed':
            case 'BotFailed':
            case 'CallbackCanceled':
            case 'CancelledByAgent':
            case 'CustomerJoinFailed':
            case 'InternalError':
            case 'TransferToAgentFailed':
            case 'TransferToExternalFailed':
            case 'CustomerDisconnected':
                return 'red';

            case 'Handled':
            case 'AgentConnected':
                return 'green';

            case 'QueueTimedOut':
            case 'EstimatedWaitTimeLimitReached':
            case 'QueueSizeLimitReached':
            case 'IdleTimeout':
                return 'orange';

            case 'CallbackRequested':
            case 'TransferredToQueue':
            case 'TransferToChannel':
                return 'blue';

            case 'TransferToExternal':
                return 'purple';

            case 'Default':
            case 'ConversationEnded':
            case 'NoAgentLoggedIn':
            case 'NoAvailableStaffedAgent':
            case 'NoStaffedAgentLoggedIn':
            case 'Unspecified':
            default:
                return 'grey';
        }
    }
}
